/// ====
// Primary timeline
export const STEP_START = 0;
export const STEP_UPCOMING = 1;
// TODO: deprecated constant
export const STEP_COMPETITION = 100;
export const STEP_WHITELIST = 2;
export const STEP_PURCHASE = 3;
export const STEP_CLAIM = 4;
export const STEP_CLOSE = 5;

/// ====
// Secondary timeline
export const STEP_WHITELIST_APPLIED = 22;
export const STEP_WHITELIST_CLOSE = 23;
export const STEP_WHITELIST_WIN = 24;
export const STEP_WHITELIST_FAIL = 25;

export const STEP_PURCHASE_START = 31;
export const STEP_PURCHASE_SUCCESS = 32;
// export const STEP_PURCHASE_FAIL = 33;
export const STEP_PURCHASE_CLOSE = 34;

/// ====
// Timeline status
export const STATUS = {
    BEFORE: 0,
    INPROGRESS: 1,
    AFTER: 2,
};
